import { render, staticRenderFns } from "./OpenapiList.vue?vue&type=template&id=5b6f2812&scoped=true&"
import script from "./OpenapiList.vue?vue&type=script&lang=js&"
export * from "./OpenapiList.vue?vue&type=script&lang=js&"
import style0 from "./OpenapiList.vue?vue&type=style&index=0&id=5b6f2812&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f2812",
  null
  
)

export default component.exports